import { Tabs } from 'antd';

import styled, { css } from 'styled-components';

// FEATURESDRAWER.JS

export const FeatureSetContainer = styled.div`
    padding: 0 1.6rem;
`;

// DRAGGABLETABS.JS

export const StyledTabs = styled(Tabs)`
    .ant-tabs-nav {
        background-color: #fff;

        .ant-tabs-nav-wrap {
            padding-left: 2rem;
        }
    }
`;

// FEATURESGROUP.JS

export const FeatureGroupContainer = styled.div`
    margin-bottom: 4rem;
`;

export const FeatureBoxContainer = styled.div`
    /* display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start; */
    /* width: 100%; */
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;

    .feature-box {
        /* width: 25%; */
        grid-column: span 1;
        background-color: #fff;
        /* border-right: 1rem solid ${(props) => props.theme.LayoutBodyBackground}; */
        border-bottom: 1rem solid ${(props) => props.theme.LayoutBodyBackground};
        box-sizing: border-box;

        &.span-2 {
            /* width: 50%; */
            grid-column: span 2;
        }
        &.span-4 {
            /* width: 100%; */
            grid-column: span 4;
        }
        &.active {
            background-color: ${(props) => props.theme.WarningColor};
        }

        .feature-box-header {
            border-bottom: 1px solid ${(props) => props.theme.LayoutBodyBackground};
            padding: 0.5rem;
            text-transform: uppercase;
            font-size: 0.8rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .feature-box-content {
            padding: 0;
            width: 100%;
            min-height: 5rem;
            display: flex;
            flex-direction: column;
            /* justify-content: flex-start; */
            justify-content: center;
            align-items: center;

            .feature-value {
                font-size: 1.4rem;
                line-height: 1.1rem;
                font-weight: 500;
                text-align: center;
                padding: 0.5rem 1rem 0 1rem;
                flex: 1;
                width: 100%;

                &.text-medium {
                    font-size: 1.2rem;
                }
                &.text-small {
                    font-size: 1rem;
                    font-weight: 300;
                    text-align: left;
                    padding: 0.5rem 1rem;
                }
                &.text-list {
                    em {
                        display: block;
                        line-height: 1.2rem;
                        font-style: normal;
                        text-align: left;
                    }
                }
            }
        }

        &.has-public-value {
            .feature-box-content {
                .public-feature-value {
                    color: ${(props) => props.theme.PrimaryColor};
                }

                .feature-value {
                    flex: 0 1 auto;
                    font-size: 1.15rem;
                    padding: 0.35rem 0.75rem 0 0.75rem;

                    &.text-medium {
                        font-size: 1rem;
                    }
                    &.text-small {
                        font-size: 0.85rem;
                        padding: 0.35rem 0.75rem;
                    }
                    &.public-feature-value {
                        font-size: 0.95rem;
                        padding-top: 0.15rem;
                        padding-bottom: 0.35rem;
                    }
                    &.public-feature-value.text-medium {
                        font-size: 0.9rem;
                    }
                    &.public-feature-value.text-small {
                        font-size: 0.8rem;
                    }
                }
            }
        }

        &.has-inline-public-value {
            .feature-box-content {
                justify-content: center;

                .feature-inline-values {
                    display: flex;
                    justify-content: center;
                    align-items: baseline;
                    width: 100%;
                    padding: 0.35rem 0.75rem 0;

                    .feature-value {
                        flex: 0 0 auto;
                        width: auto;
                        font-size: 1.4rem;
                        line-height: 1.1rem;
                        padding: 0;
                    }

                    .public-feature-value {
                        color: ${(props) => props.theme.PrimaryColor};
                    }
                }

                .feature-inline-separator {
                    margin: 0 0.25rem;
                    color: ${(props) => props.theme.TextColorMuted};
                    font-size: 1rem;
                    line-height: 1rem;
                }
            }
        }

        &.feature-conversion {
            .feature-box-content {
                justify-content: space-between;

                .feature-value {
                    width: 100%;
                    //flex: 2 0 0;
                }

                .feature-metrics {
                    width: 100%;
                    //flex: 1 0 0;
                    display: flex;
                    justify-content: space-between;
                    border-top: ${(prop) => prop.theme.DefaultBorder};

                    span {
                        flex: 1 0 0;
                        border-right: ${(prop) => prop.theme.DefaultBorder};
                        font-size: 0.6rem;
                        text-transform: uppercase;
                        text-align: center;
                        padding: 1px 0;
                        cursor: pointer;

                        &:last-child {
                            border-right: none;
                        }

                        &.active-metric {
                            background-color: ${(prop) => prop.theme.PrimaryColor};
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
`;

export const FeatureContentWrapper = styled.div`
    margin-bottom: 4px;

    span {
        font-weight: bold;
    }

    .feature-inline-separator {
        margin: 0 0.25rem;
        font-weight: normal;
        color: ${(props) => props.theme.TextColorMuted};
    }

    .public-feature-value {
        color: ${(props) => props.theme.PrimaryColor};
    }
`;

/**
 * Valore pubblico in coda a quello privato, tra parentesi invece che dopo il bullet.
 * Serve nei riepiloghi compatti (card e lista modelle) dove il bullet separa già le feature.
 */
export const parenthesizedPublicValueStyles = css`
    .feature-inline-separator {
        display: none;
    }

    .public-feature-value {
        margin-left: 0.25em;

        &::before {
            content: '(';
        }

        &::after {
            content: ')';
        }
    }
`;
